/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Faq_A3Inputs */

const en_csv_to_json_faq_a3 = /** @type {(inputs: Csv_To_Json_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, every value is emitted as a string. CSV carries no type information, and guessing would turn a postal code like 07030 into 7030 and a part number like 1E5 into 100000. Convert the columns you know are numeric in your own code.`)
};

const ko_csv_to_json_faq_a3 = /** @type {(inputs: Csv_To_Json_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그렇습니다. 모든 값이 문자열로 나옵니다. CSV는 타입 정보를 담지 않으며, 추측하면 07030 같은 우편번호가 7030이 되고 1E5 같은 부품 번호가 100000이 됩니다. 숫자라고 아는 열은 직접 코드에서 변환하세요.`)
};

const ja_csv_to_json_faq_a3 = /** @type {(inputs: Csv_To_Json_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、すべての値が文字列として出ます。CSV は型情報を持たず、推測すれば 07030 のような郵便番号が 7030 になり、1E5 のような部品番号が 100000 になります。数値だと分かっている列は自分のコードで変換してください。`)
};

/**
* | output |
* | --- |
* | "Yes, every value is emitted as a string. CSV carries no type information, and guessing would turn a postal code like 07030 into 7030 and a part number like 1..." |
*
* @param {Csv_To_Json_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_faq_a3 = /** @type {((inputs?: Csv_To_Json_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_faq_a3(inputs)
	if (locale === "ko") return ko_csv_to_json_faq_a3(inputs)
	return ja_csv_to_json_faq_a3(inputs)
});